import { motion, useScroll, useSpring } from "framer-motion";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { HughAcronym } from "@/components/HughAcronym";
import { PortalShowcase } from "@/components/PortalShowcase";
import { PlaybookCTA } from "@/components/PlaybookCTA";
import { Pricing } from "@/components/Pricing";
// Archived per user request — re-add <CaseStudies /> (components/CaseStudies.jsx) when needed.
// import { CaseStudies } from "@/components/CaseStudies";
import { ShowcaseCarousel } from "@/components/ShowcaseCarousel";
import { About } from "@/components/About";
import { IsItForMe } from "@/components/IsItForMe";
import { NextSteps } from "@/components/NextSteps";
import { FAQ } from "@/components/FAQ";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function Landing() {
  useSmoothScroll();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.2 });
  return (
    <div className="relative bg-[#0A0C0F]">
      <Seo
        title="HughLaunch — Grow Bolder. Launch Faster."
        description="HughLaunch is the growth partner for local businesses ready to win online. Web design, brand strategy and client-acquisition systems that turn your website into a booking machine."
        path="/"
        image="https://hughlaunch.com/icon-512.png"
      />
      <motion.div
        style={{ scaleX }}
        className="fixed top-0 left-0 right-0 z-[70] h-[3px] origin-left bg-[#C6FF00]"
        data-testid="scroll-progress"
        aria-hidden="true"
      />
      <Navbar />
      <main>
        {/* 1. Hook */}
        <Hero />
        <Marquee />
        {/* 2. The problem & belief — why this matters */}
        <Manifesto />
        {/* 3. What we do */}
        <Services />
        {/* 4. How we do it */}
        <HughAcronym />
        {/* 5. Proof — the work */}
        <ShowcaseCarousel />
        {/* 6. Differentiator — the client experience */}
        <PortalShowcase />
        {/* 7. Social proof & founder trust */}
        <Testimonials />
        <About />
        {/* 8. The offer */}
        <Pricing />
        {/* 9. Qualification + objections */}
        <IsItForMe />
        <FAQ />
        {/* 10. Not ready yet? Lead magnet */}
        <PlaybookCTA />
        <Marquee reverse />
        {/* 11. Action */}
        <NextSteps />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
